/** @type {String} */
export let ctaCaption;
/** @type {String} */
export let ctaLabel;
export let ctaHref = '';
/** @type {String} */
export let description;
/** @type {any} */
export let media;


import UspRow from './UspRow.svelte';

export default {
  component: UspRow,
  name: 'USP Row',
  inputs: [
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'description',
      type: 'richText'
    },
    {
      name: 'imagePlacement',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'imageDesktop',
      type: 'file'
    },
    {
      name: 'imageMobile',
      type: 'file'
    },
    {
      name: 'ctaLabel',
      type: 'string'
    },
    {
      name: 'ctaCaption',
      type: 'string'
    },
    {
      name: 'ctaHref',
      type: 'string'
    },
  ]
}
